<template>
  <el-card>
    <div>
      <h1>签名机制</h1>
      <el-divider />
      <p class="doc">途签电子签署平台对每个请求进行身份验证，所以无论使用 HTTP 还是 HTTPS 协议提交请求，都需要在请求中包含签名（Signature）信息
      客户端调用 API 时，需要使用已授权签名秘钥对请求内容的关键数据进行加密签名计算，并且将 Key 和加密后生成的字符串放在请求的 Header 传输给途签，
      途签会读取请求中的头信息，并且根据 Key 的值查询到对应的 Secret 的值，使用 Secret 对收到的请求中的签名数据进行签名计算，
      并且使用自己的生成的签名和客户端传上来的签名进行比对，来验证签名的正确性。只有签名验证通过的请求才会进行后续业务处理，
      否则途签会认为该请求为非法请求，直接返回错误应答。</p>
      <p>签名用到的 accessKeyId 和 accessKeySecret 在商务签约后获取</p>
      <h2>签名及验签原理</h2>
      <p class="doc">以下参与签名的字段，需要在每个请求的 Header 中加入：</p>
      <el-table
        :data='[{"p":"sign-version","d":"固定传值：v1或v2"},{"p":"sign-access-key","d":"accessKeyId（商务签约后获取）"},{"p":"sign-access-nonce","d":"随机字符串，建议使用UUID"},{"p":"sign-access-auth","d":"签名计算后得到的签名字符串"}]'
        border
        style="width: 100%">
        <el-table-column
          prop="p"
          label="Header 参数">
        </el-table-column>
        <el-table-column
          prop="d"
          label="描述">
        </el-table-column>
      </el-table>
      <h3>v1</h3>
      <p>（该签名算法存在安全隐患，即将弃用，建议使用v2）</p>
      <p>将 accessKeyId 及 accessKeySecret 连接后进行 base64 计算得到签名字符串</p>
      <p>代码示例：</p>
      <pre v-highlight><code class="java">
String accessKeyId = "8324913147064fa1";
String accessKeySecret = "8aac94386090d948";
String stringToSign = accessKeyId + accessKeySecret; // 8324913147064fa18aac94386090d948
String signAccessAuth = Base64.getMimeEncoder()
                .encodeToString(stringToSign.getBytes()); // ODMyNDkxMzE0NzA2NGZhMThhYWM5NDM4NjA5MGQ5NDg=
        </code></pre>
        <p>将计算得到的字符串放入请求的 Header 中</p>
        <pre v-highlight><code class="http">
POST esign/api/contract/template/sign/10023 HTTP/1.1
Host: api.toursign.cn
sign-version: v1
sign-access-key: 8324913147064fa1
sign-access-auth: ODMyNDkxMzE0NzA2NGZhMThhYWM5NDM4NjA5MGQ5NDg=
Content-Type: application/json

{
    // body
}
        </code></pre>
      <p>服务器接收到请求后从 Header 中取出 sign-access-key 与 sign-access-auth 进行签名验证，通过后进行后续业务处理，不通过则返回错误</p>
      <h3>v2</h3>
      <p>将 accessKeyId 、随机字符串与毫秒时间戳连接后使用 accessKeySecret 进行 HmacSHA1 加密，然后使用 Base64 算法进行编码，形成最终的签名</p>
      <p>代码示例：</p>
      <pre v-highlight><code class="java">
String accessKeyId = "8324913147064fa1";
String nonce = "c9f15cbf-f4ac-4a6c-b54d-f51abf4b5b44";
String timestamp = "1577836800123";
String accessKeySecret = "8aac94386090d948";
String stringToSign = accessKeyId + nonce + timestamp; // 8324913147064fa1c9f15cbf-f4ac-4a6c-b54d-f51abf4b5b441577836800123

Mac hmacSha1 =  Mac.getInstance("HmacSHA1");
byte[] keyBytes = accessKeySecret.getBytes("UTF-8");
hmacSha1.init(new SecretKeySpec(keyBytes, 0, keyBytes.length, "HmacSHA1"));
byte[] md5Result = hmacSha1.doFinal(stringToSign.getBytes("UTF-8"));

String signAccessAuth = Base64.getUrlEncoder().encodeToString(md5Result); // gDL_eM94eKSF1X1lGOHg1O83dLg=

        </code></pre>
        <p>将 accessKeyId、nonce、timestamp 与计算得到的字符串放入请求的 Header 中</p>
        <pre v-highlight><code class="http">
POST esign/api/contract/template/sign/10023 HTTP/1.1
Host: api.toursign.cn
sign-version: v2
sign-access-key: 8324913147064fa1
sign-access-nonce: c9f15cbf-f4ac-4a6c-b54d-f51abf4b5b44
sign-access-timestamp: 1577836800123
sign-access-auth: gDL_eM94eKSF1X1lGOHg1O83dLg=
Content-Type: application/json

{
    // body
}
        </code></pre>
      <p>服务器接收到请求后从 Header 中取出 sign-access-key、sign-access-nonce、sign-access-timestamp 与 sign-access-auth 进行签名验证，通过后进行后续业务处理，不通过则返回错误</p>
    </div>
</el-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>
